module.exports = "<label for=\"{{ id }}\" class=\"h5\">{{ label }}</label>\r\n<select class=\"custom-select\" id=\"{{ id }}\"\r\n        (change)=\"onSettingsChanged($event.target.value)\">\r\n  <option *ngFor=\"let device of devices\"\r\n          [value]=\"device.deviceId\" [selected]=\"device.deviceId === selectedId\">\r\n    {{ device.label }}\r\n  </option>\r\n</select>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/device-select/device-select.component.html
// module id = ./src/app/device-select/device-select.component.html
// module chunks = main